import styled from 'styled-components'

export const Wrapper = styled.div`
  gap: var(--spacer-2);
`

Wrapper.displayName = 'Wrapper'
